export const GET_TASK_REQUEST = "GET_TASK_REQUEST";
export const GET_TASK_SUCCESS = "GET_TASK_SUCCESS";
export const GET_TASK_FAIL =    "GET_TASK_FAIL";
  
export const POST_TASK_REQUEST = "POST_TASK_REQUEST";
export const POST_TASK_SUCCESS = "POST_TASK_SUCCESS";
export const POST_TASK_FAIL = "POST_TASK_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";

// Add these to your existing task constants
export const CREATE_TASK_REQUEST = "CREATE_TASK_REQUEST";
export const CREATE_TASK_SUCCESS = "CREATE_TASK_SUCCESS";
export const CREATE_TASK_FAIL = "CREATE_TASK_FAIL";
export const CREATE_TASK_RESET = "CREATE_TASK_RESET";

export const UPDATE_TASK_REQUEST = "UPDATE_TASK_REQUEST";
export const UPDATE_TASK_SUCCESS = "UPDATE_TASK_SUCCESS";
export const UPDATE_TASK_FAIL = "UPDATE_TASK_FAIL";
export const UPDATE_TASK_RESET = "UPDATE_TASK_RESET";

export const DELETE_TASK_REQUEST = "DELETE_TASK_REQUEST";
export const DELETE_TASK_SUCCESS = "DELETE_TASK_SUCCESS";
export const DELETE_TASK_FAIL = "DELETE_TASK_FAIL";
export const DELETE_TASK_RESET = "DELETE_TASK_RESET";

export const GET_TASKS_BY_GROUP_REQUEST = "GET_TASKS_BY_GROUP_REQUEST";
export const GET_TASKS_BY_GROUP_SUCCESS = "GET_TASKS_BY_GROUP_SUCCESS";
export const GET_TASKS_BY_GROUP_FAIL = "GET_TASKS_BY_GROUP_FAIL";